// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slider-label {
  color: #AEAEAE;
  font-size: 12px;
  padding-left: 27px;
}

.slider-label-selected {
  color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/features/food/common/tab-view/component/price-range/price-range.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,eAAA;EACA,kBAAA;AACJ;;AAEA;EACI,uBAAA;AACJ","sourcesContent":[".slider-label {\n    color: #AEAEAE;\n    font-size: 12px;\n    padding-left: 27px;\n}\n\n.slider-label-selected {\n    color: white !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
